import { useEffect } from "react";
import { atom, useRecoilState } from "recoil";

const tryParse = <T>(value: string | null, defaultValue: T): T => {
    if (!value) return defaultValue;
    try {
        return JSON.parse(value);
    } catch {
        return defaultValue;
    }
}

const SettingObject = atom<displaySettings>({
    key: "SettingObject",
    default: global && global.localStorage ? tryParse(localStorage.getItem("setting"), {
        theme: "light",
        type: "scrolled",
        fontSize: "100%"
    }): {
        theme: "light",
        type: "scrolled",
        fontSize: "100%"
    }
});

export const useReaderSetting = () => {

    const [setting, setSetting] = useRecoilState(SettingObject);

    const setType     = (type: displaySettings['type'])         => setSetting(setting => ({ ...setting, type }));
    const setTheme    = (theme: displaySettings['theme'])       => setSetting(setting => ({ ...setting, theme}));
    const setFontSize = (fontSize: displaySettings['fontSize']) => setSetting(setting => ({ ...setting, fontSize }));

    useEffect(()=> {
        localStorage.setItem("setting", JSON.stringify(setting));
    },[setting]);

    return {
        setting,
        setType, setTheme, setFontSize,
    };
}